<template>
    <div class="">
        <div class="my-content-start">
            <div class="card ma-4 cardContraste" aria-label="Card à esquerda, para mudar senha." style="min-width: 435px;">
                <div class="card-header ">
                    <span class="acessibilidade" style="font-size: 20px">Minha senha</span>                    
                </div>
                <div class="card-body">
                    <div class="card-text">
                        <form>
                            <div class="form-group">
                                <div class="input-group input-group-lg">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                        <i class="fas fa-lock"></i>
                                        </div>
                                    </div>
                                    <input 
                                    type="password"
                                    placeholder="Senha atual"
                                    v-model="form.senhaAtual"
                                    class="form-control"
                                    v-bind:class="{'is-invalid' : errorMessages.senhaAtual.message !== ''}"
                                    style="background-image: none !important"                                                                    
                                    @input="validarCampo(errorMessages.senhaAtual, form.senhaAtual)"
                                    >
                                </div>
                                <div role="alert">
                                    <small class="form-text text-danger" v-show="errorMessages.senhaAtual.message !== '' " >{{errorMessages.senhaAtual.message}}</small>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group input-group-lg">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                        <i class="fas fa-lock"></i>
                                        </div>
                                    </div>
                                    <input 
                                    type="password"
                                    placeholder="Senha nova"
                                    v-model="form.novaSenha"
                                    class="form-control"
                                    v-bind:class="{'is-invalid' : errorMessages.novaSenha.message !== ''}"
                                    style="background-image: none !important"                                                                    
                                    @input="validarCampo(errorMessages.novaSenha, form.novaSenha)"                                                                    
                                    >                                                                   
                                </div>
                                <div role="alert">
                                    <small class="form-text text-danger" v-show="errorMessages.novaSenha.message !== '' " >{{errorMessages.novaSenha.message}}</small>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group input-group-lg">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                        <i class="fas fa-lock"></i>
                                        </div>
                                    </div>
                                    <input 
                                    type="password"
                                    placeholder="Repetir senha"
                                    v-model="form.confirmaSenha"
                                    class="form-control"
                                    v-bind:class="{'is-invalid' : errorMessages.confirmaSenha.message !== ''}"
                                    style="background-image: none !important"                                                                    
                                    @input="validarCampo(errorMessages.confirmaSenha, form.confirmaSenha)"                                                                       
                                    >                                                                   
                                </div>
                                <div role="alert">
                                    <small class="form-text text-danger" v-show="errorMessages.confirmaSenha.message !== '' " >{{errorMessages.confirmaSenha.message}}</small>
                                </div>
                            </div>
                            <v-btn class="right mt-0" icon dark small color="success"  @click="mudarSenha()" title="Salvar senha" aria-label="Salvar senha.">
                                <v-icon dark >check</v-icon>
                            </v-btn>
                        </form>
                    </div>
                </div>
            </div>
            <!-- <v-skeleton-loader></v-skeleton-loader> -->
            <div class="card ma-4 cardContraste" aria-label="Card ao centro, para mudar telefone." style="min-width: 435px;">
                <div class="card-header">
                    <span class="acessibilidade" style="font-size:20px; ">Telefone</span>
                    <v-btn @click="abrirNovoTel()" class="right bg-first-dark mt-0" icon dark small title="Novo telefone" aria-label="Novo telefone.">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </div>
                <div class="card-body" v-bind:class="{'scroll-y': !small, 'style-teste': !small}">
                    <div class="card-text">
                        <form v-if="novoTel || (celulares.length === 0 && residenciais.length === 0 && comerciais.length === 0)">
                            <div class="form-group">
                                <div class="input-group input-group-lg">
                                    <div class="input-group-prepend">
                                        <label class="input-group-text"><i class="fas fa-phone-square-alt"></i></label>
                                    </div>
                                    <select
                                    @change="validarSelect(form.objTelefone.errorMessages.tipoTel, form.objTelefone.tipoTel)"
                                    class="custom-select" 
                                    id="inputGroupSelect01"
                                    v-model="form.objTelefone.tipoTel"
                                    v-bind:class="{'is-invalid' : form.objTelefone.errorMessages.tipoTel.message!== ''}"
                                    style="background-image: none !important"                                                                
                                    >
                                    <option v-for="item in tiposTelefone" :value="item" :key="item.codigo">{{item.nome}}</option>
                                    </select>
                                </div>
                                <div role="alert">
                                    <small class="form-text text-danger" v-show="form.objTelefone.errorMessages.tipoTel.message!== '' " >{{form.objTelefone.errorMessages.tipoTel.message}}</small>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group input-group-lg">
                                    <div class="input-group-prepend">
                                        <label class="input-group-text"><i class="fas fa-phone"></i></label>
                                    </div>
                                    <input 
                                    type="text"
                                    class="form-control"
                                    placeholder="Telefone"
                                    v-model="form.objTelefone.nrTelefoneFormat"
                                    v-mask="['(##) ####-####','(##) #####-####']"
                                    @input="validarCampo(form.objTelefone.errorMessages, form.objTelefone.nrTelefoneFormat)"
                                    v-bind:class="{'is-invalid' : form.objTelefone.errorMessages.telefone.message !== ''}"
                                    style="background-image: none !important"
                                    >
                                </div>
                                <div role="alert">
                                    <small class="form-text text-danger" v-show="form.objTelefone.errorMessages.telefone.message!== '' " >{{form.objTelefone.errorMessages.telefone.message}}</small>
                                </div>
                            </div>
                            <div class="form-group">
                                <!-- <v-btn class="left mt-0" icon dark small color="error" aria-label="Excluir telefone." title="Excluir telefone">
                                    <i class="far fa-trash-alt"></i>
                                </v-btn> -->
                                <v-btn @click="salvarTelefone(form.objTelefone)" class="right mt-0" icon dark small color="success" aria-label="Salvar telefone." title="Salvar telefone">
                                    <v-icon dark>check</v-icon>
                                </v-btn>

                            </div>
                            <hr style="clear: both">
                        </form>
                        <h4 class="acessibilidade" style="clear: both" v-show="celulares.length !== 0 ">Celulares</h4>
                        <form tabindex="0" @focus="item.showBtn = true" v-show="celulares.length !== 0 " v-for="(item) in celulares" :key="'cel' + item.idTelefone">
                            <v-hover>
                                <div slot-scope="{hover}">
                                    <div class="form-group">
                                        <div class="input-group input-group-lg">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text"><i class="fas fa-phone-square-alt"></i></label>
                                            </div>
                                            <select
                                            @change="validarSelect(item.errorMessages.tipoTel, item.tipoTel)"
                                            class="custom-select"
                                            v-model="item.tipoTel.codigo"
                                            v-bind:class="{'is-invalid' : item.errorMessages.tipoTel.message !== ''}"
                                            style="background-image: none !important"                                                                
                                            >
                                            <option v-for="item in tiposTelefone" :value="item.codigo" :key="item.codigo">{{item.nome}}</option>
                                            </select>
                                        </div>
                                        <div role="alert">
                                            <small class="form-text text-danger" v-show="item.errorMessages.tipoTel.message!== '' " >{{item.errorMessages.tipoTel.message}}</small>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group input-group-lg">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text"><i class="fas fa-phone"></i></label>
                                            </div>
                                            <input
                                            type="text"
                                            :id="'tel-' + item.idTelefone"
                                            class="form-control"
                                            placeholder="Telefone"
                                            v-model="item.nrTelefoneFormat"
                                            v-mask="['(##) ####-####','(##) #####-####']"
                                            @input="validarCampo(item.errorMessages.telefone, item.nrTelefoneFormat)"
                                            v-bind:class="{'is-invalid' : item.errorMessages.telefone.message !== ''}"
                                            style="background-image: none !important"
                                            >
                                        </div>
                                        <div role="alert">
                                            <small class="form-text text-danger" v-show="item.errorMessages.telefone.message!== '' " >{{item.errorMessages.telefone.message}}</small>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="hover || item.showBtn" v-bind:class="{'right': !small}">
                                        <!-- <v-btn class="left mt-0" icon dark small color="error" aria-label="Excluir telefone." title="Excluir telefone">
                                            <i class="far fa-trash-alt"></i>
                                        </v-btn> -->
                                        <v-btn @click="salvarTelefone(item)" @blur="item.showBtn = false" class="right mt-0" icon dark small color="success" aria-label="Salvar telefone." title="Salvar telefone">
                                            <v-icon dark>check</v-icon>
                                        </v-btn>
                                    </div>
                                    <hr style="clear: both">
                                </div>
                            </v-hover>
                        </form>
                        <h4 class="acessibilidade" style="clear: both" v-show="residenciais.length !== 0 ">Residenciais</h4>
                        <form tabindex="0" @focus="item.showBtn = true" v-show="residenciais.length !== 0 " v-for="(item) in residenciais" :key="'res' + item.idTelefone">
                            <v-hover>
                                <div slot-scope="{hover}">
                                    <div class="form-group">
                                        <div class="input-group input-group-lg">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text"><i class="fas fa-phone-square-alt"></i></label>
                                            </div>
                                            <select
                                            @change="validarSelect(item.errorMessages.tipoTel, item.tipoTel)"
                                            class="custom-select"
                                            v-model="item.tipoTel.codigo"
                                            v-bind:class="{'is-invalid' : item.errorMessages.tipoTel.message !== ''}"
                                            style="background-image: none !important"                                                                
                                            >
                                            <option v-for="item in tiposTelefone" :value="item.codigo" :key="item.codigo">{{item.nome}}</option>
                                            </select>
                                        </div>
                                        <div role="alert">
                                            <small class="form-text text-danger" v-show="item.errorMessages.tipoTel.message!== '' " >{{item.errorMessages.tipoTel.message}}</small>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group input-group-lg">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text"><i class="fas fa-phone"></i></label>
                                            </div>
                                            <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Telefone"
                                            v-model="item.nrTelefoneFormat"
                                            v-mask="['(##) ####-####','(##) #####-####']"
                                            @input="validarCampo(item.errorMessages.telefone, item.nrTelefoneFormat)"
                                            v-bind:class="{'is-invalid' : item.errorMessages.telefone.message !== ''}"
                                            style="background-image: none !important"
                                            >
                                        </div>
                                        <div role="alert">
                                            <small class="form-text text-danger" v-show="item.errorMessages.telefone.message!== '' " >{{item.errorMessages.telefone.message}}</small>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="hover || item.showBtn" v-bind:class="{'right': !small}">
                                        <v-btn @click="salvarTelefone(item)" @blur="item.showBtn = false" class="right mt-0" icon dark small color="success" aria-label="Salvar telefone." title="Salvar telefone">
                                            <v-icon dark>check</v-icon>
                                        </v-btn>
                                    </div>
                                    <hr style="clear: both">
                                </div>
                            </v-hover>
                        </form>
                        <h4 class="acessibilidade" style="clear: both" v-show="comerciais.length !== 0 ">Comerciais</h4>
                        <form tabindex="0" @focus="item.showBtn = true" v-show="comerciais.length !== 0 " v-for="(item) in comerciais" :key="'com' +item.idTelefone">
                            <v-hover>
                                <div slot-scope="{hover}">
                                    <div class="form-group">
                                        <div class="input-group input-group-lg">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text"><i class="fas fa-phone-square-alt"></i></label>
                                            </div>
                                            <select
                                            @change="validarSelect(item.errorMessages.tipoTel, item.tipoTel)"
                                            class="custom-select"
                                            v-model="item.tipoTel.codigo"
                                            v-bind:class="{'is-invalid' : item.errorMessages.tipoTel.message !== ''}"
                                            style="background-image: none !important"                                                                
                                            >
                                            <option v-for="item in tiposTelefone" :value="item.codigo" :key="item.codigo">{{item.nome}}</option>
                                            </select>
                                        </div>
                                        <div role="alert">
                                            <small class="form-text text-danger" v-show="item.errorMessages.tipoTel.message!== '' " >{{item.errorMessages.tipoTel.message}}</small>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group input-group-lg">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text"><i class="fas fa-phone"></i></label>
                                            </div>
                                            <input 
                                            type="text"
                                            class="form-control"
                                            placeholder="Telefone"
                                            v-model="item.nrTelefoneFormat"
                                            v-mask="['(##) ####-####','(##) #####-####']"
                                            @input="validarCampo(item.errorMessages.telefone, item.nrTelefoneFormat)"
                                            v-bind:class="{'is-invalid' : item.errorMessages.telefone.message !== ''}"
                                            style="background-image: none !important"
                                            >
                                        </div>
                                        <div role="alert">
                                            <small class="form-text text-danger" v-show="item.errorMessages.telefone.message!== '' " >{{item.errorMessages.telefone.message}}</small>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="hover || item.showBtn" v-bind:class="{'right': !small}">
                                        <v-btn @click="salvarTelefone(item)" @blur="item.showBtn = false" class="right mt-0" icon dark small color="success" aria-label="Salvar telefone." title="Salvar telefone">
                                            <v-icon dark>check</v-icon>
                                        </v-btn>
                                    </div>
                                    <hr style="clear: both">
                                </div>
                            </v-hover>
                        </form>
                    </div>
                </div>
            </div>
            <div class="card ma-4 cardContraste" aria-label="Card à direita, para mudar email." style="min-width: 435px;">
                <div class="card-header">
                    <span class="acessibilidade" style="font-size: 20px">E-mail</span>
                    <v-btn @click="abrirNovoEmail()" class="right bg-first-dark mt-0" icon dark  small title="Novo e-mail" aria-label="Novo e-mail.">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </div>
                <div class="card-body" v-bind:class="{'scroll-y': !small, 'style-teste': !small}">
                    <div class="card-text" >
                        <form v-show="novoEmail || emails.length === 0">
                            <div >
                                <div class="form-group">
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" >@</span>
                                        </div>
                                        <input 
                                        type="text" 
                                        class="form-control" 
                                        placeholder="E-mail" 
                                        aria-label="E-mail."
                                        @input="validandoEmail(form.objEmail)"
                                        v-model="form.objEmail.email" 
                                        v-bind:class="{'is-invalid' : form.objEmail.errorMessages.email.message !== ''}"
                                        style="background-image: none !important; min-width:350px"
                                        >
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="form.objEmail.errorMessages.email.message!== '' " >{{form.objEmail.errorMessages.email.message}}</small>
                                    </div>
                                </div>
                                <div class="form-group ma-2">
                                    <v-btn @click="salvarEmail(form.objEmail)" class="right mt-0" icon dark small color="success" aria-label="Salvar e-mail." title="Salvar e-mail">
                                        <v-icon dark>check</v-icon>
                                    </v-btn>

                                </div>
                            </div>
                            <hr style="clear: both">
                        </form>
                        <form v-show="emails.length !== 0" v-for="(item, i) in emails" :key="i">
                            <!-- <v-hover > -->
                                <!-- <div slot-scope="{hover}" > -->
                                    <div >
                                        <div class="form-group">
                                            <div class="input-group input-group-lg">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" >@</span>
                                                </div>
                                                <input 
                                                
                                                type="text" 
                                                class="form-control" 
                                                placeholder="E-mail" 
                                                aria-label="E-mail."
                                                @input="validandoEmail(item)"
                                                v-model="item.email" 
                                                v-bind:class="{'is-invalid' : item.errorMessages.email.message !== ''}"
                                                style="background-image: none !important; min-width:350px"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.email.message!== '' " >{{item.errorMessages.email.message}}</small>
                                            </div>
                                        </div>
                                        <!-- <div class="form-group ma-2" v-if="hover">
                                            <v-btn class="left mt-0" icon dark small color="error" aria-label="Excluir e-mail." title="Excluir e-mail">
                                                <i class="far fa-trash-alt"></i>
                                            </v-btn>
                                            <v-btn @click="salvarEmail(item)" class="right mt-0" icon dark small color="success" aria-label="Salvar e-mail." title="Salvar e-mail">
                                                <v-icon dark>check</v-icon>
                                            </v-btn>

                                        </div> -->
                                    </div>
                                    <hr style="clear: both">
                                <!-- </div> -->
                            <!-- </v-hover> -->
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="card ma-3 cardContraste" aria-label="Card ao centro, para mudar endereço.">
                <div class="card-header">
                    <span class="acessibilidade" style="font-size: 20px">Endereço</span>
                    <v-btn @click="abrirNovoEndereco()" class="right bg-first-dark mt-0" icon dark  small title="Novo endereço" aria-label="Novo endereço.">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </div>
                <div class="card-body" >
                    <div class="card-text">
                        <form class="form-horizontal" v-show="novoEndereco || (endComerciais.length === 0 && endResidenciais.length === 0)">
                            <div class="content-flex-row">
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">Tipo de endereço:</h6>
                                    <div class="input-group input-group-lg">
                                        <select
                                        class="form-control" 
                                        v-model="form.objEndereco.tipoEnd"
                                        @change="validarSelect(form.objEndereco.errorMessages.tipoEnd, form.objEndereco.tipoEnd)"
                                        v-bind:class="{'is-invalid' : form.objEndereco.errorMessages.tipoEnd.message !== ''}"
                                        style="background-image: none !important; width: 218px"                                                                
                                        >
                                        <option v-for="item in tiposEndereco" :value="item" :key="item.codigo">{{item.nome}}</option>
                                        </select>
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="form.objEndereco.errorMessages.tipoEnd.message!== '' " >{{form.objEndereco.errorMessages.tipoEnd.message}}</small>
                                    </div>
                                </div>
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">CEP:</h6>
                                    <div class="input-group input-group-lg">
                                        <input 
                                        type="text"
                                        class="form-control"
                                        placeholder="CEP"
                                        v-model="form.objEndereco.cep"
                                        v-mask="'##.###-###'"
                                        @input="validarCampo(form.objEndereco.errorMessages.cep, form.objEndereco.cep)"
                                        v-bind:class="{'is-invalid' : form.objEndereco.errorMessages.cep.message !== ''}"
                                        style="background-image: none !important"
                                        >
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="form.objEndereco.errorMessages.cep.message!== '' " >{{form.objEndereco.errorMessages.cep.message}}</small>
                                    </div>
                                </div>
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">Endereço:</h6>
                                    <div class="input-group input-group-lg">
                                        <input 
                                        type="text"
                                        class="form-control"
                                        placeholder="Endereço"
                                        v-model="form.objEndereco.endereco"
                                        @input="validarCampo(form.objEndereco.errorMessages.endereco, form.objEndereco.endereco)"
                                        v-bind:class="{'is-invalid' : form.objEndereco.errorMessages.endereco.message !== ''}"
                                        style="background-image: none !important"
                                        >
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="form.objEndereco.errorMessages.endereco.message!== '' " >{{form.objEndereco.errorMessages.endereco.message}}</small>
                                    </div>
                                </div>
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">Número:</h6>
                                    <div class="input-group input-group-lg">
                                        <input 
                                        type="text"
                                        class="form-control"
                                        placeholder="Número"
                                        v-model="form.objEndereco.numero"
                                        @input="validarCampo(form.objEndereco.errorMessages.numero, form.objEndereco.numero)"
                                        v-bind:class="{'is-invalid' : form.objEndereco.errorMessages.numero.message !== ''}"
                                        style="background-image: none !important"
                                        >
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="form.objEndereco.errorMessages.numero.message!== '' " >{{form.objEndereco.errorMessages.numero.message}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="content-flex-row">
                            
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">Complemento:</h6>
                                    <div class="input-group input-group-lg">
                                        <input 
                                        type="text"
                                        class="form-control"
                                        placeholder="Complemento"
                                        v-model="form.objEndereco.complemento"
                                        >
                                    </div>
                                </div>
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">Bairro:</h6>
                                    <div class="input-group input-group-lg">
                                        <input
                                        type="text" 
                                        class="form-control"
                                        placeholder="Bairro"
                                        v-model="form.objEndereco.bairro"
                                        @input="validarCampo(form.objEndereco.errorMessages.bairro, form.objEndereco.bairro)"
                                        v-bind:class="{'is-invalid' : form.objEndereco.errorMessages.bairro.message !== ''}"
                                        style="background-image: none !important"
                                        >
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="form.objEndereco.errorMessages.bairro.message!== '' " >{{form.objEndereco.errorMessages.bairro.message}}</small>
                                    </div>
                                </div>
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">Cidade:</h6>
                                    <div class="input-group input-group-lg">
                                        <input 
                                        type="text"
                                        class="form-control"
                                        placeholder="Cidade"
                                        v-model="form.objEndereco.cidade"
                                        @input="validarCampo(form.objEndereco.errorMessages.cidade, form.objEndereco.cidade)"
                                        v-bind:class="{'is-invalid' : form.objEndereco.errorMessages.cidade.message !== ''}"
                                        style="background-image: none !important"
                                        >
                                    </div>
                                    <div role="alert">
                                        <small class="form-text text-danger" v-show="form.objEndereco.errorMessages.cidade.message!== '' " >{{form.objEndereco.errorMessages.cidade.message}}</small>
                                    </div>
                                </div>
                                <div class="form-group ma-2">
                                    <h6 class="colorLabel">Estado:</h6>
                                    <selectEstado :estado.sync="form.objEndereco.estado"></selectEstado>                                                            
                                </div>
                            </div>
                            <div class="form-group ma-3" v-bind:class="{'right': !small}">
                                <v-btn @click="salvarEndereco(form.objEndereco)" class="right mt-0" icon dark small color="success" aria-label="Salvar endereço." title="Salvar endereço">
                                    <v-icon dark>check</v-icon>
                                </v-btn>

                            </div> 
                            <hr style="clear: both">
                        </form>
                        <h4 class="acessibilidade"  v-show="endResidenciais.length !== 0" style="clear: both">Residenciais</h4>
                        <form tabindex="0" @focus="item.showBtn = true" style="clear: both" class="form-horizontal" v-show="endResidenciais.length !== 0" v-for="(item) in endResidenciais" :key="'r'+item.idEndereco">
                            <v-hover>
                                <div slot-scope="{hover}">                            
                                    <div class="content-flex-row">
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Tipo de endereço:</h6>
                                            <div class="input-group input-group-lg">
                                                <select
                                                class="form-control"
                                                v-model="item.tipoEnd"
                                                @change="validarSelect(item.errorMessages.tipoEnd, item.tipoEnd)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.tipoEnd.message !== ''}"
                                                style="background-image: none !important; width: 218px"                                                                
                                                >
                                                <option v-for="item in tiposEndereco" :value="item" :key="item.codigo">{{item.nome}}</option>
                                                </select>
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.tipoEnd.message!== '' " >{{item.errorMessages.tipoEnd.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">CEP:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="CEP"
                                                v-model="item.cep"
                                                v-mask="'##.###-###'"
                                                @input="validarCampo(item.errorMessages.cep, item.cep)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.cep.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.cep.message!== '' " >{{item.errorMessages.cep.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Endereço:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Endereço"
                                                v-model="item.endereco"
                                                @input="validarCampo(item.errorMessages.endereco, item.endereco)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.endereco.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.endereco.message!== '' " >{{item.errorMessages.endereco.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Número:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Número"
                                                v-model="item.numero"
                                                @input="validarCampo(item.errorMessages.numero, item.numero)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.numero.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.numero.message!== '' " >{{item.errorMessages.numero.message}}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="content-flex-row">
                                    
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Complemento:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Complemento"
                                                v-model="item.complemento"
                                                >
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Bairro:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Bairro"
                                                v-model="item.bairro"
                                                @input="validarCampo(item.errorMessages.bairro, item.bairro)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.bairro.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.bairro.message!== '' " >{{item.errorMessages.bairro.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Cidade:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Cidade"
                                                v-model="item.cidade"
                                                @input="validarCampo(item.errorMessages.cidade, item.cidade)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.cidade.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.cidade.message!== '' " >{{item.errorMessages.cidade.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Estado:</h6>
                                            <selectEstado :estado.sync="item.estado"></selectEstado>                                                            
                                        </div>
                                    </div>
                                    <div class="form-group ma-3" v-if="hover || item.showBtn" v-bind:class="{'right': !small}">
                                        <v-btn @click="salvarEndereco(item)" @blur="item.showBtn = false" class="right mt-0" icon dark small color="success" aria-label="Salvar endereço." title="Salvar endereço">
                                            <v-icon dark>check</v-icon>
                                        </v-btn>

                                    </div>
                                    <hr style="clear: both">
                                </div>
                            </v-hover>
                        </form>
                        <h4 class="acessibilidade" v-show="endComerciais.length !== 0" style="clear: both">Comerciais</h4>
                        <form tabindex="0" @focus="item.showBtn = true" style="clear: both" class="form-horizontal" v-show="endComerciais.length !== 0" v-for="(item) in endComerciais" :key="'c' + item.idEndereco">
                            <v-hover>
                                <div slot-scope="{hover}">                           
                                    <div class="content-flex-row">
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Tipo de endereço:</h6>
                                            <div class="input-group input-group-lg">
                                                <select
                                                class="form-control"
                                                v-model="item.tipoEnd"
                                                @change="validarSelect(item.errorMessages.tipoEnd, item.tipoEnd)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.tipoEnd.message !== ''}"
                                                style="background-image: none !important; width: 218px"                                                                
                                                >
                                                <option v-for="item in tiposEndereco" :value="item" :key="item.codigo">{{item.nome}}</option>
                                                </select>
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.tipoEnd.message!== '' " >{{item.errorMessages.tipoEnd.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">CEP:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="CEP"
                                                v-model="item.cep"
                                                v-mask="'##.###-###'"
                                                @input="validarCampo(item.errorMessages.cep, item.cep)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.cep.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.cep.message!== '' " >{{item.errorMessages.cep.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Endereço:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Endereço"
                                                v-model="item.endereco"
                                                @input="validarCampo(item.errorMessages.endereco, item.endereco)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.endereco.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.endereco.message!== '' " >{{item.errorMessages.endereco.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Número:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Número"
                                                v-model="item.numero"
                                                @input="validarCampo(item.errorMessages.numero, item.numero)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.numero.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.numero.message!== '' " >{{item.errorMessages.numero.message}}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="content-flex-row">
                                    
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Complemento:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Complemento"
                                                v-model="item.complemento"
                                                >
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Bairro:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Bairro"
                                                v-model="item.bairro"
                                                @input="validarCampo(item.errorMessages.bairro, item.bairro)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.bairro.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.bairro.message!== '' " >{{item.errorMessages.bairro.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Cidade:</h6>
                                            <div class="input-group input-group-lg">
                                                <input 
                                                type="text"
                                                class="form-control"
                                                placeholder="Cidade"
                                                v-model="item.cidade"
                                                @input="validarCampo(item.errorMessages.cidade, item.cidade)"
                                                v-bind:class="{'is-invalid' : item.errorMessages.cidade.message !== ''}"
                                                style="background-image: none !important"
                                                >
                                            </div>
                                            <div role="alert">
                                                <small class="form-text text-danger" v-show="item.errorMessages.cidade.message!== '' " >{{item.errorMessages.cidade.message}}</small>
                                            </div>
                                        </div>
                                        <div class="form-group ma-2">
                                            <h6 class="colorLabel">Estado:</h6>
                                            
                                            <selectEstado :estado.sync="item.estado"></selectEstado>                                                            
                                        </div>
                                    </div>
                                    <div class="form-group ma-3" v-if="hover || item.showBtn" v-bind:class="{'right': !small}">
                                        <!-- <v-btn class="left mt-0" icon dark small color="error" aria-label="Excluir endereço." title="Excluir endereço">
                                            <i class="far fa-trash-alt"></i>
                                        </v-btn> -->
                                        <v-btn @click="salvarEndereco(item)" @blur="item.showBtn = false" class="right mt-0" icon dark small color="success" aria-label="Salvar endereço." title="Salvar endereço">
                                            <v-icon dark>check</v-icon>
                                        </v-btn>

                                    </div>
                                    <hr style="clear: both">
                                </div>
                            </v-hover>
                        </form>                      
                    </div>
                </div>
            </div>
        </div>
        <Carregando></Carregando>
    </div>
</template>
<script>
import Vuex from '@/vuex/store'
import bus from '@/service/bus'
// import $ from 'jquery'
import selectEstado from './MyComponents/selectEstado'
import { patchSenha, postTelefone, postEmail, postEndereco, getTiposTelefone, getTiposEndereco, getTelefones, getEmails, getEnderecos } from '@/service/service_autoatendimento/autoatendimento'
import Carregando from './MyComponents/Carregando.vue'
// import { constants } from 'fs';
export default {
    components: {Carregando, selectEstado},
    data(){
        return {
            novoTel: false,
            novoEmail: false,
            novoEndereco: false,
            loadingTel: true,
            loadingEmail: true,
            loadingEnd: true,
            form: {
                objTelefone: {
                    nrTelefoneFormat: '',
                    idTelefone: 0,
                    cdCredor: 0,
                    tipoTel: {
                        nome: 'ESCOLHA',
                        codigo: -1
                    },
                    errorMessages: {
                        telefone: {
                            message: ''
                        },
                        tipoTel: {
                            message: ''
                        },
                    }

                },
                objEmail: {
                    email: '',
                    cdCredor: 0,
                    errorMessages: {
                        email: {
                            message: ''
                        },
                    }
                },
                objEndereco: {
                    tipoEnd: {
                        nome: 'ESCOLHA',
                        codigo: -1
                    },
                    cep: '',
                    endereco: '',
                    complemento: '',
                    numero: '',
                    bairro: '',
                    cidade: '',
                    idEndereco: 0,
                    cdCredor: 0,
                    estado:{
                        sigla: '',
                        erro: ''
                    },
                    errorMessages: {
                        tipoEnd: {
                            message: ''
                        },
                        cep: {
                            message: ''
                        },
                        numero: {
                            message: ''
                        },
                        endereco: {
                            message: ''
                        },
                        bairro: {
                            message: ''
                        },
                        cidade: {
                            message: ''
                        }
                    }
                },
                senhaAtual: '',
                novaSenha: '',
                confirmaSenha: ''
            },
            celulares: [],
            comerciais: [],
            residenciais: [],
            emails: [],
            endComerciais: [],
            endResidenciais: [],
            tiposEndereco: [
                {
                    nome: 'ESCOLHA',
                    codigo: -1
                },                
            ],
            tiposTelefone: [
                {
                    nome: 'ESCOLHA',
                    codigo: -1
                },
            ],
            showSenhaAtual: false,
            showNovaSenha: false,
            showConfirmaSenha: false,
            errorMessages: {
                senhaAtual: {
                    message: ''
                },
                novaSenha: {
                    message: ''
                },
                confirmaSenha: {
                    message: ''
                },

            }
        }
    },
    computed: {
        small(){
            return !Vuex.state.large
        }
    },
    mounted(){
        window.fonte('cadastro')
        if(window.innerWidth >= 750)  Vuex.commit('SET_TELA', true)
        window.onresize = ()=>{
            if(window.innerWidth >= 750) Vuex.commit('SET_TELA', true)  
            else Vuex.commit('SET_TELA', false)  
        }
        this.carregaTiposTelefone()
        this.carregaTiposEndereco()
        this.carregaTelefones()
        this.carregaEmails()
        
    },
    methods: {
        showBtn(item){
            item.showBtn = true
            
        },
        hideBtn(item){
            item.showBtn = false
            // console.log('opaaaa :)')
        },
        validarCampo(message, campo){
            if(campo.length === 0){
                message.message = 'Campo obrigatório'
            } else {
                message.message = ''
            }
        },
        validandoEmail(obj){
            if(obj.email.length === 0) obj.errorMessages.email.message = 'Campo obrigatório'
            else if(!/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi.test(obj.email))  obj.errorMessages.email.message = 'Inválido'            
            else obj.errorMessages.email.message = ''
        },
        validarSelect(message, select){
            if(select.codigo === -1) message.message = 'Campo obrigatório'
            else message.message = ''
        },
        carregaTelefones() {
            try {
                // bus.$emit('load-in', {text: 'Carregando'})
                this.celulares = []
                this.residenciais = []
                this.comerciais = []
                getTelefones().then(response => {
                    this.celulares = response.data.Retorno.celular.map(item =>{
                        item.showBtn = false
                        item.nrTelefoneFormat = item.nrDDD.toString() + item.nrTelefone.toString()
                        var indexC = this.tiposTelefone.findIndex((item)=> item.nome === 'CELULAR')
                        item.tipoTel = {
                            codigo: this.tiposTelefone[indexC].codigo,
                            nome: 'CELULAR'
                        }
                        item.errorMessages = {
                            tipoTel: {
                                message: '',
                            },
                            telefone: {
                                message: ''
                            } 
                        }
                        return item
                    })
                    this.residenciais = response.data.Retorno.residencial.map(item =>{
                        item.showBtn = false
                        item.nrTelefoneFormat = item.nrDDD.toString() + item.nrTelefone.toString()
                        var indexR = this.tiposTelefone.findIndex((item)=> item.nome === 'RESIDENCIAL')
                        item.tipoTel = {
                            codigo: this.tiposTelefone[indexR].codigo,
                            nome: 'RESIDENCIAL'
                        } 
                        item.errorMessages = {
                            tipoTel: {
                                message: '',
                            },
                            telefone: {
                                message: ''
                            } 
                        }
                        return item
                    })
                    this.comerciais = response.data.Retorno.comercial.map(item =>{
                        item.showBtn = false
                        item.nrTelefoneFormat = item.nrDDD.toString() + item.nrTelefone.toString()
                        var indexCR = this.tiposTelefone.findIndex((item)=> item.nome === 'COMERCIAL')
                        item.tipoTel = {
                            codigo: this.tiposTelefone[indexCR].codigo,
                            nome: 'COMERCIAL'
                        } 
                        item.errorMessages = {
                            tipoTel: {
                                message: '',
                            },
                            telefone: {
                                message: ''
                            } 
                        }
                        return item
                    })
                    // bus.$emit('load-out')
                    this.loadingTel = false
                }).catch(()=>{
                    
                    // bus.$emit('load-out')
                })
            } catch(error){
                this.loadingTel = false
                // bus.$emit('load-out')
            }
        },
        carregaEmails(){
            try {
                getEmails().then(response =>{
                    this.emails = response.data.Retorno.email.map(it => {
                        var obj = {
                            email: it,
                            errorMessages: {
                                email: {
                                    message: ''
                                }
                            },
                            hover: false
                        }
                        return obj
                    })
                    this.loadingEmail = false
                })

            } catch(error){
                // bus.$emit('load-out')
                this.loadingEmail = false
            }
        },
        carregaEnderecos(){
            try {
                getEnderecos().then(response => {
                    this.endComerciais = response.data.Retorno.comercial.map(item => {
                        var indexC = this.tiposEndereco.findIndex(item => item.nome === 'COMERCIAL')
                        item = {
                            showBtn: false,
                            idEndereco: item.idEndereco,
                            tipoEnd: this.tiposEndereco[indexC],
                            cep: item.cep,
                            endereco: item.logradouro,
                            complemento: item.complemento,
                            numero: item.numero,
                            bairro: item.bairro,
                            cidade: item.cidade,
                            estado: {
                                sigla: item.UF,
                                erro: ''
                            },                            
                            errorMessages: {
                                tipoEnd: {
                                    message: ''
                                },
                                cep: {
                                    message: ''
                                },
                                numero: {
                                    message: ''
                                },
                                endereco: {
                                    message: ''
                                },
                                bairro: {
                                    message: ''
                                },
                                cidade: {
                                    message: ''
                                }
                            }
                        }
                        return item
                    })
                    this.endResidenciais = response.data.Retorno.residencial.map(item => {
                        var index = this.tiposEndereco.findIndex(item => item.nome === 'RESIDENCIAL')
                        item = {
                            showBtn: false,
                            idEndereco: item.idEndereco,
                            tipoEnd: {
                                nome: 'RESIDENCIAL',
                                codigo: this.tiposEndereco[index].codigo
                            },
                            cep: item.cep,
                            endereco: item.logradouro,
                            complemento: item.complemento,
                            numero: item.numero,
                            bairro: item.bairro,
                            cidade: item.cidade,
                            estado: {
                                sigla: item.UF,
                                erro: ''
                            },
                            errorMessages: {
                                tipoEnd: {
                                    message: ''
                                },
                                cep: {
                                    message: ''
                                },
                                numero: {
                                    message: ''
                                },
                                endereco: {
                                    message: ''
                                },
                                bairro: {
                                    message: ''
                                },
                                cidade: {
                                    message: ''
                                }
                            }
                        }
                        return item
                    })
                    // bus.$emit('load-out')
                    this.loadingEnd = false
                })
            } catch(error){
                // bus.$emit('load-out')
                this.loadingEnd = false
            }
        },
        async carregaTiposTelefone(){
            try {
                var response = await getTiposTelefone()
                this.tiposTelefone = this.tiposTelefone.concat(response.data.Retorno)
            } catch(error){
                // console.log('erro', error)
            }
        },
        abrirNovoTel(){
            this.form.objTelefone.idTelefone = 0
            this.form.objTelefone.tipoTel.codigo = -1
            this.form.objTelefone.tipoTel.nome = 'ESCOLHA'
            this.form.objTelefone.nrTelefoneFormat = ''
            this.form.objTelefone.errorMessages.tipoTel.message = ''
            this.form.objTelefone.errorMessages.telefone.message = ''
            this.novoTel = !this.novoTel
        },
        abrirNovoEmail(){
            this.form.objEmail.email = ''
            this.form.objEmail.errorMessages.email.message = ''
            this.novoEmail = !this.novoEmail
        },
        abrirNovoEndereco(){
            this.form.objEndereco.idEndereco = 0
            this.form.objEndereco.tipoEnd = {
                nome: 'ESCOLHA',
                codigo: -1
            },
            this.form.objEndereco.cep = '',
            this.form.objEndereco.endereco = '',
            this.form.objEndereco.complemento = '',
            this.form.objEndereco.numero = '',
            this.form.objEndereco.complemento = '',
            this.form.objEndereco.bairro = '',
            this.form.objEndereco.cidade = '',
            this.form.objEndereco.estado.sigla = ''
            this.form.objEndereco.errorMessages = {
                tipoEnd: {
                    message: ''
                },
                cep: {
                    message: ''
                },
                numero: {
                    message: ''
                },
                endereco: {
                    message: ''
                },
                bairro: {
                    message: ''
                },
                cidade: {
                    message: ''
                }
            }
            this.novoEndereco = !this.novoEndereco
        },
        async carregaTiposEndereco(){
            try {
                var response = await getTiposEndereco()
                this.tiposEndereco = this.tiposEndereco.concat(response.data.Retorno)
                this.carregaEnderecos()
            } catch(error){
                // console.log('erro', error)
            }
        },
        async mudarSenha(){
            try {
                if(this.form.senhaAtual === ''){
                    this.errorMessages.senhaAtual.message = 'Campo obrigatório'
                    return
                }
                if(this.form.novaSenha === ''){
                    this.errorMessages.novaSenha.message = 'Campo obrigatório'
                    return
                }
                if(this.form.confirmaSenha === ''){
                    this.errorMessages.confirmaSenha.message = 'Campo obrigatório'
                    return
                }
                if(this.form.novaSenha !== this.form.confirmaSenha){
                    this.errorMessages.confirmaSenha.message = 'Senha diferente'
                    return
                }                
                var obj = {
                    senhaAtual: this.form.senhaAtual,
                    senhaNova: this.form.novaSenha
                }
                bus.$emit('load-in', {text: 'Carregando'})
                await patchSenha(obj)
                bus.$emit('load-out')
                this.$swal({
                    type: 'success',
                    title: 'Sucesso',
                    text:'Senha alterada com sucesso.'
                })
                this.limpaFormSenha()

            } catch(error){
                bus.$emit('load-out')
                this.limpaFormSenha()
                this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text:'Erro ao mudar a senha.'
                })
            }
        },
        limpaFormSenha(){
            this.form.senhaAtual = ''
            this.form.novaSenha = ''
            this.form.confirmaSenha = ''
            this.errorMessages.senhaAtual.message = ''
            this.errorMessages.novaSenha.message = ''
            this.errorMessages.confirmaSenha.message = ''
        },
        async salvarTelefone(obj) {
            try {
                if(obj.tipoTel.codigo === -1){
                    obj.errorMessages.tipoTel.message = 'Campo obrigatório'
                    return
                }
                var txtTel = obj.nrTelefoneFormat.replace(/[^0-9]/g, '')
                if(txtTel.length === 0) {
                    obj.errorMessages.telefone.message = 'Campo obrigatório'
                    return
                }
                if(txtTel.length !== 10 && txtTel.length !== 11) {
                    obj.errorMessages.telefone.message = 'Número inválido'
                    return
                }
                var tel = {
                    nrDDD: Number(txtTel.slice(0,2)),
                    nrTelefone: Number(txtTel.slice(2)),
                    cdTipoTelefone: obj.tipoTel.codigo,
                    idTelefone: obj.idTelefone,
                }
                bus.$emit('load-in', {text: 'Carregando'})
                // var response =  await postTelefone(tel)
                postTelefone(tel).then(() => {
                    this.novoTel = false
                    this.carregaTelefones()
                    bus.$emit('load-out')
                    this.$swal({
                        type: 'success',
                        title: 'Sucesso!',
                        text: 'Telefone salvo com sucesso'
                    }) 

                }).catch(error =>{
                    bus.$emit('load-out')
                    this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text:error.response.data.Message
                    })                   
                })
            } catch(error) {
                bus.$emit('load-out')
                this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text:error.response.data.Message
                })   

            }
        },
        async salvarEmail(obj){
            try {
                if(obj.email === '') {
                    obj.errorMessages.email.message = 'Campo obrigatório'
                    return
                } else if (!(/.+@.+/.test(obj.email))) {
                    obj.errorMessages.email.message = 'E-mail inválido'
                    return
                }
                await postEmail({NmEmail:obj.email})
                this.carregaEmails()
                this.novoEmail = false
                this.$swal({
                    type: 'success',
                    title: 'Sucesso!',
                    text: 'E-mail salvo com sucesso'
                }) 
            } catch(error){
                this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text:'Erro ao salvar e-mail.'
                })
            }
        },
        // buscarCEP(obj) {
        //     // try {
        //     //     let cep = obj.cep.replace(/\D/g, '')
        //     //     $.getJSON('https://viacep.com.br/ws/' + cep +'/json/?callback=?').then( response => {
        //     //         if(!("erro" in response)) {
        //     //             obj.endereco = response.logradouro
        //     //             obj.bairro = response.bairro
        //     //             obj.cidade = response.localidade
        //     //             obj.estado.sigla = response.uf

        //     //         } else {
        //     //             obj.errorMessages.cep.message = 'CEP inválido'
        //     //         }
        //     //     }).catch(() => {
        //     //         obj.errorMessages.cep.message = 'CEP inválido'
        //     //     });
        //     // } catch(error) {
        //     //     obj.errorMessages.cep.message = 'CEP inválido'
        //     // }
        // },
        salvarEndereco(obj){
            try {
                var txtCep = obj.cep.replace(/[^0-9]/g, '')
                if(obj.tipoEnd.codigo === -1){
                    obj.errorMessages.tipoEnd.message = 'Campo obrigatório'
                    return
                }
                if(obj.cep === '') {
                    obj.errorMessages.cep.message = 'Campo obrigatório'
                    return
                } else if(txtCep.length !== 8) {
                    obj.errorMessages.cep.message = 'CEP inválido'
                    return
                }
                if(obj.endereco === ''){
                    obj.errorMessages.endereco.message = 'Campo obrigatório'
                    return
                }
                if(obj.numero === ''){
                    obj.errorMessages.numero.message = 'Campo obrigatório'
                    return
                }
                if(obj.bairro === ''){
                    obj.errorMessages.bairro.message = 'Campo obrigatório'
                    return
                }
                if(obj.cidade === ''){
                    obj.errorMessages.cidade.message = 'Campo obrigatório'
                    return
                }
                if(obj.estado.sigla === '' || obj.estado.sigla === undefined ){
                    obj.estado.erro = 'Campo obrigatório'
                    return
                }       
                // console.log('aquii end')         
                var endereco = {
                    idEndereco: obj.idEndereco,
                    cdTipoEndereco: obj.tipoEnd.codigo,
                    UF: obj.estado.sigla,
                    cidade: obj.cidade,
                    logradouro: obj.endereco,
                    numero: obj.numero,
                    complemento: obj.complemento,
                    bairro: obj.bairro,
                    cep: Number(txtCep),
                }
                bus.$emit('load-in', {text: 'Carregando'})
                postEndereco(endereco).then(() => {
                    this.novoEndereco = false
                    this.carregaEnderecos()
                    bus.$emit('load-out')
                    this.$swal({
                        type: 'success',
                        title: 'Sucesso!',
                        text: 'Endereco salvo com sucesso'
                    })
                }).catch(error => {
                    bus.$emit('load-out')
                    this.$swal({
                        type: 'error',
                        title: 'Oops...',
                        text:error.response.data.Message
                    })   
                })
            } catch(error) {

                // console.log(error)
            }
        }
    }
}
</script>